import React from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import {withRouter} from 'react-router'
import MenuItem from './MenuItem'
import UserAction from "./UserAction"
import _checkRoles from "../../../../helpers/checkRole"
import {getLocalData} from "../../../../services/StorageServices";

NavbarLeftContainer.propTypes = {
    onClickToggle: PropTypes.func.isRequired,
    onClickMenuItem: PropTypes.func.isRequired,
    isCollapsed: PropTypes.bool.isRequired
}

function NavbarLeftContainer(props) {
    let timer = null

    let logoCollapse = null
    let logoExpand = null

    const logoTenant = getLocalData('logoTenant')
    if (logoTenant !== null) {
        if (logoTenant.length > 0) {
            if (logoTenant.find(item => item.layoutField === "expandMenu") !== undefined) logoExpand = "/logo/" + logoTenant.find(item => item.layoutField === "expandMenu").fieldTitle
            if (logoTenant.find(item => item.layoutField === "collapseMenu") !== undefined) logoCollapse = "/logo/" + logoTenant.find(item => item.layoutField === "collapseMenu").fieldTitle
        }
    }

    const _getNavbar = () => {
        const subCustomers = []
        const subSetting = []
        const subReport = []
        const subHotline = []

        if (_checkRoles('menu.hotline.checkHotline')) {
            subHotline.push({
                title: 'Check số hotline',
                href: '/crm/check-hotline-number',
            })
        }

        if (_checkRoles('menu.customer.customer')) {
            subCustomers.push({
                title: 'Quản lý khách hàng',
                href: '/crm/customers',
            })
        }

        if (_checkRoles('menu.customer.customerList')) {
            subCustomers.push({
                title: 'Danh sách khách hàng',
                href: '/crm/list-customers',
            })
        }

        if (_checkRoles('menu.setting.user')) {
            subSetting.push({
                title: 'Quản lý user',
                href: '/crm/manager-user',
            })
        }

        if (_checkRoles('menu.setting.department')) {
            subSetting.push({
                title: 'Quản lý team',
                href: '/crm/department',
            })
        }

        if (_checkRoles('menu.setting.role')) {
            subSetting.push({
                title: 'Quản lý quyền',
                href: '/crm/setting-role',
            })
        }

        if (_checkRoles('menu.setting.layout')) {
            subSetting.push({
                title: 'Quản lý layout',
                href: '/crm/setting-layout',
            })
        }

        if (_checkRoles('menu.setting.callcenter')) {
            subSetting.push({
                title: 'Quản lý tổng đài',
                href: '/crm/call-center',
            })
        }

        if (_checkRoles('menu.setting.tenantParam')) {
            subSetting.push({
                title: 'Quản lý tenant',
                href: '/crm/setting-tenant',
            })
        }

        if (_checkRoles('menu.setting.tenantDealer')) {
            subSetting.push({
                title: 'Quản lý tenant đại lý',
                href: '/crm/setting-tenant-dealer',
            })
        }

        if (_checkRoles('menu.report.call.fee')) {
            subReport.push({
                title: 'Báo cáo chi tiết cước',
                href: '/crm/report-call-fee',
            })
        }

        if (_checkRoles('menu.report.call.fee.new')) {
            subReport.push({
                title: 'Báo cáo chi tiết cước (t-1)',
                href: '/crm/report-call-fee-new',
            })
        }

        if (_checkRoles('menu.report.hubPhoneNumber')) {
            subReport.push({
                title: 'Báo cáo đầu số',
                href: '/crm/report-hub-phone-number',
            })
        }

        if (_checkRoles('menu.report.hub.CustPhone.v2')) {
            subReport.push({
                title: 'Báo cáo đầu số khách hàng theo hướng V2',
                href: '/crm/report-hub-cust-phone-v2',
            })
        }

        if (_checkRoles('menu.report.hub.CustPhone')) {
            subReport.push({
                title: 'Báo cáo đầu số khách hàng theo hướng',
                href: '/crm/report-hub-cust-phone',
            })
        }

        if (_checkRoles('menu.report.hub.sub.detail')) {
            subReport.push({
                title: 'Báo cáo admin',
                href: '/crm/report-detail-sub',
            })
        }

        if (_checkRoles('menu.customerhub.reportVoicemail')) {
            subReport.push({
                title: 'Báo cáo chi tiết cuộc gọi Voice Mail',
                href: '/crm/report-call-detail',
            })
        }

        if (_checkRoles('menu.report.benefit.by.sale')) {
            subReport.push({
                title: 'Báo cáo hoa hồng sale',
                href: '/crm/report-benefit',
            })
        }

        const menu = []

        if (_checkRoles('menu.dashboard')) {
            const itemLead = {
                title: 'Dashboard',
                fa: 'home',
                href: '/crm/dashboard',
            }

            menu.splice(0, 0, itemLead)
        }

        if (_checkRoles('menu.customer')) {
            const itemCustomer = {
                title: 'Customers',
                fa: 'person',
                sub_menu: subCustomers
            }

            menu.splice(1, 0, itemCustomer)
        }

        if (_checkRoles('menu.customerhub')) {
            const itemCustomersHub = {
                title: 'Quản lý khách hàng',
                fa: 'person',
                href: '/crm/customers-hub',
            }

            menu.splice(2, 0, itemCustomersHub)
        }

        if (_checkRoles('menu.manage.phoneNumber')) {
            const itemPhoneNumbersHub = {
                title: 'Quản lý đầu số',
                fa: 'book',
                href: '/crm/phone-number-hub',
            }

            menu.splice(3, 0, itemPhoneNumbersHub)
        }

        if (_checkRoles('menu.hotline')) {
            const itemReport = {
                title: 'Đầu số',
                fa: 'filter_9',
                sub_menu: subHotline
            }

            menu.splice(4, 0, itemReport)
        }

        if (_checkRoles('menu.report')) {
            const itemReport = {
                title: 'Report & Dashboard',
                fa: 'timelapse',
                sub_menu: subReport
            }

            menu.splice(5, 0, itemReport)
        }

        if (_checkRoles('menu.setting')) {
            const itemSetting = {
                title: 'Settings',
                fa: 'settings',
                sub_menu: subSetting
            }

            menu.splice(7, 0, itemSetting)
        }

        return menu
    }

    const _handleClickToggleHiddenMenu = () => {
        const {onClickMenuItem} = props

        if (timer) clearTimeout(timer)

        timer = setTimeout(onClickMenuItem, 350)
    }

    const {isCollapsed, onClickToggle} = props
    const navbar = _getNavbar()

    const toggleMenuMobile = () => {
        const body = document.getElementsByTagName("body")[0];
        if (body.getAttribute('data-menu-mobile') === 'openMenuMobile') {
            body.removeAttribute('data-menu-mobile')
        } else {
            body.setAttribute('data-menu-mobile', 'openMenuMobile')
        }
    }

    return (
        <div className='NavbarLeft'>
            <div className={`SideBarToggle ${isCollapsed ? 'Open' : 'Close'}`} onClick={onClickToggle}>
                {
                    isCollapsed ?
                        <span className="material-icons">chevron_right</span>
                        :
                        <span className="material-icons">chevron_left</span>
                }
            </div>
            <div className='NavbarMask' onClick={toggleMenuMobile}/>

            <div className='NavbarLeftInner d-flex justify-content-between'>
                {(logoExpand !== null && logoCollapse !== null) && <div className="Logo">
                    <Link to='/'>
                        <img src={isCollapsed ? logoCollapse : logoExpand} alt="logo"/>
                    </Link>
                </div>}
                <nav className='PrimaryMenu'>
                    {
                        navbar.map((nav, index) => (<MenuItem
                                length={navbar.length}
                                index={index}
                                key={nav.title}
                                menuItem={nav}
                                onClickMenuItem={_handleClickToggleHiddenMenu}
                                {...props}
                            />
                        ))
                    }
                </nav>

                <nav className='BottomMenu'>
                    {
                        _checkRoles('menu.help') && <div className="support">
                            <a href="https://alohub.vn/huong-dan-su-dung/" target="_blank" rel="noreferrer">
                                <span className="material-icons">help_outline</span>
                                Trợ giúp
                            </a>
                        </div>
                    }

                    <UserAction/>
                </nav>
            </div>
        </div>
    )
}

function NavbarLeftWithAuth(props) {
    return <NavbarLeftContainer {...props} />
}

export default withRouter(NavbarLeftWithAuth)
